import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Typed from "typed.js";
import SeoMeta from "../../components/SeoMeta";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const { t } = useTranslation();
  const typedRef = useRef(null);
  const navigate = useNavigate();
	

  const seo = {
    metaTitle: t("notFound.seoTitle"),
    metaDescription: t("notFound.seoDescription"),
  };

  useEffect(() => {
    const typed = new Typed(typedRef.current, {
      strings: [
        "Je suis désolé",
        "Lo siento",
        "Ik ben droevig",
        "Sono spiacente",
        "Perdóname",
      ],
      typeSpeed: 50,
      backSpeed: 10,
      loop: true,
      showCursor: true,
    });

    return () => typed.destroy();
  }, []);

  const handleBackHome = () => {
    navigate("/", { replace: true }); // ✅ replaces current entry in history
  };
	
	
  return (
    <>
      <SeoMeta seo={seo} />

      <section className="py-10">
        <div className="d-flex flex-column container min-vh-100">
          <div className="row align-items-center justify-content-center justify-content-lg-between my-auto">
            <div className="col-md-10 order-lg-1 text-center text-lg-start">
              <h1 className="display-2">
                <span style={{fontWeight: "bold"}} ref={typedRef}></span>
                <br />
                {t("notFound.title")}
              </h1>

              <button
                onClick={handleBackHome}
                className="btn btn-rounded btn-outline-dark mt-4">
                {t("notFound.backHome")}
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
